<template>
  <v-card :style="backOpacity">
    <v-card-title>ボタンフォーム ButtonForm.vue</v-card-title>
    <v-card-text>
      <v-container>
        <v-form ref="form" v-model="valid">
          {{ rules }}
          ルール数[{{ rules.length }}]
          <v-row>
            <v-col cols="auto">
              <v-text-field
                label="ラベル"
                v-model="returnData.label"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-checkbox
                v-model="rules[10]"
                label="ムダミエールボタン"
                value="true"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <set-Cols
                :value="String(returnData.cols)"
                v-on:set="$set(returnData, 'cols', $event)"
              ></set-Cols>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="8">
              <v-radio-group label="保存データ" v-model="rules[0]" row>
                <v-radio label="時刻" value="0"></v-radio>
                <v-radio label="固定値" value="1"></v-radio>
                <v-radio label="特定フォームの値" value="2"></v-radio>
                <v-radio label="何も保存しない" value="3"></v-radio>
                <v-radio label="画像のダウンロード" value="4"></v-radio>
              </v-radio-group>
            </v-col>
            <v-col cols="4" v-if="rules[0] == '1'">
              <v-text-field
                label="初期値"
                v-model="returnData.init"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="4" v-else-if="rules[0] == '2'">
              <v-text-field
                label="特定フォームID ※同一ページのみ指定可"
                v-model="returnData.init"
                required
                :rules="[varidation.numonly]"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-select
                :items="$store.state.colors"
                :background-color="returnData.color"
                v-model="returnData.color"
                label="ボタンの色"
                :rules="[varidation.required]"
              ></v-select>
            </v-col>
            <v-col>
              <v-select
                :items="textColors"
                item-text="label"
                item-value="value"
                v-model="textColor"
                label="テキストの色"
              ></v-select
            ></v-col>
          </v-row>
          <!------------------------------- ---->
          <v-row>
            <v-col cols="4" v-if="rules[0] == 4">
              <v-text-field
                label="画像ダウンロード対象フォームID"
                :rules="[]"
                v-model="rules[22]"
                required
              ></v-text-field>
            </v-col>
          </v-row>
          <!----------------------------- ---->
          <v-row rows="12">
            <v-col cols="1">ボタン動作</v-col>
            <v-col cols="2">
              <v-checkbox
                v-model="rules[1]"
                label="1回だけ入力"
                value="required"
              ></v-checkbox>
            </v-col>
            <v-col cols="2">
              <v-checkbox
                v-model="rules[7]"
                label="サブページ連動"
                value="true"
              ></v-checkbox>
            </v-col>
            <v-col cols="3">
              <v-checkbox
                v-model="rules[11]"
                label="モーダルサブページを閉じる"
                value="true"
              ></v-checkbox>
            </v-col>
            <v-col cols="2">
              <v-checkbox
                v-model="rules[21]"
                label="送信処理"
                :disabled="!rules[2]"
                value="true"
                @change="deleteRule31"
              ></v-checkbox>
              <p>※特定フォームに値を保存にチェックを入れた場合のみ選択可</p>
            </v-col>
            <v-col cols="2" v-if="rules[21] == 'true'">
              <v-checkbox
                v-model="rules[27]"
                label="送信時戻らない"
                value="true"
              ></v-checkbox>
            </v-col>
            <v-col cols="3" v-if="rules[21] == 'true'">
              <v-checkbox
                v-model="rules[30]"
                label="バリデーション判定無し"
                value="true"
              ></v-checkbox>
            </v-col>
            <v-col cols="3" v-if="rules[21] == 'true'">
              <v-checkbox
                v-model="rules[31]"
                label="送信処理後にコピー"
                value="true"
              ></v-checkbox>
              <p>※コピーボタンフォームがある前提</p>
            </v-col>
          </v-row>

          <!------------------------------- ---->
          <v-row v-if="rules[7]">
            <v-col cols="6">
              <v-checkbox
                label="サブページのモーダルON or リストサブページ追加"
                v-model="rules[9]"
                value="true"
              ></v-checkbox>
            </v-col>
            <v-col cols="3" v-if="rules[9]">
              <search-Page
                :label="'サブページのformID'"
                v-model="rules[8]"
                required
                samePage
                :initPageID="Number($route.params.page_id)"
              ></search-Page>
            </v-col>
          </v-row>
          <v-row v-if="rules[27] == 'true'">
            <v-col cols="6">
              <v-checkbox
                v-model="rules[28]"
                value="true"
                label="戻らない送信後、リストサブページ追加"
              ></v-checkbox>
            </v-col>
            <v-col cols="3" v-if="rules[28]">
              <search-Page
                :label="'サブページのformID'"
                v-model="rules[8]"
                required
                samePage
                :initPageID="Number($route.params.page_id)"
              ></search-Page>
            </v-col>
          </v-row>
          <!------------------------------------ ---->
          <v-row>
            <v-col cols="2">
              <v-checkbox v-model="rules32Flag" label="固定"></v-checkbox>
            </v-col>
            <v-col cols="4" v-if="rules32Flag">
              <v-select
                :items="fixMode"
                v-model="rules[32]"
                item-text="label"
                item-value="value"
                label="固定場所"
                :rules="[]"
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3">
              <v-checkbox
                v-model="rules33Flag"
                label="特定フォームへ移動"
              ></v-checkbox>
            </v-col>
            <v-col cols="4" v-if="rules33Flag">
              <search-Page
                :label="'移動先formID'"
                v-model="rules[33]"
                required
                samePage
                :initPageID="Number($route.params.page_id)"
              ></search-Page>
              <!-- <v-text-field
                :rules="[varidation.numonly]"
                v-model="rules[33]"
              ></v-text-field> -->
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="2">
              <v-checkbox
                v-model="rules[4]"
                label="ボタン連動"
                value="true"
              ></v-checkbox>
            </v-col>
            <v-col cols="1">
              <v-btn v-if="rules[4]" @click="add" class="ma-2">追加</v-btn>
            </v-col>
            <v-col cols="1">
              <v-btn v-if="rules[4]" @click="del" class="ma-2">削除</v-btn>
            </v-col>
            <v-col cols="3" class="ma-2" v-if="rules[7] && rules[4]">
              <search-Page
                :label="'サブページのformID'"
                v-model="rules[8]"
                required
                samePage
                :initPageID="Number($route.params.page_id)"
              ></search-Page>
            </v-col>
          </v-row>
          <v-row v-if="rules[4]"> *最初の値がonなら初期状態で入力不可 </v-row>
          <v-row v-for="(f, i) in formIDs" :key="i">
            <v-col cols="2">
              <search-Page
                v-if="rules[4]"
                :label="'formID'"
                :rules="[varidation.numonly]"
                v-model="formIDs[i]"
                required
                samePage
                :initPageID="Number($route.params.page_id)"
              ></search-Page>
              <!--
              <v-text-field
                v-if="rules[4]"
                label="formID"
                :rules="[varidation.numonly]"
                v-model="formIDs[i]"
                required
              ></v-text-field>
              -->
            </v-col>
            <v-col cols="3">
              <v-select
                v-if="rules[4]"
                :items="select"
                v-model="actions[i]"
                label="←が押されると"
                :rules="[]"
              ></v-select>
            </v-col>
          </v-row>
          <!------------------------------- ---->
          <v-row v-if="rules[21]">
            <v-col cols="2">
              <v-checkbox
                v-model="rules24Flag"
                label="メール送信"
                value="true"
              ></v-checkbox>
            </v-col>
            <v-col v-if="rules24Flag" cols="3">
              <v-text-field
                label="検索条件FormID(.区切り)"
                :rules="[]"
                v-model="mailSend[0]"
                required
              ></v-text-field>
            </v-col>
            <v-col v-if="rules24Flag" cols="5">
              <v-text-field
                label="条件値(.区切り)"
                :rules="[]"
                v-model="mailSend[1]"
                required
              ></v-text-field>
            </v-col>
            <v-col v-if="rules24Flag" cols="2">
              <v-text-field
                label="ユーザ情報ページの検索対象"
                :rules="[varidation.numonly]"
                v-model="mailSend[2]"
                required
              ></v-text-field>
            </v-col>
            <v-col v-if="rules24Flag" cols="6">
              <v-text-field
                label="メールに設定する固定値(;区切り)"
                v-model="mailSend[3]"
                required
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row v-if="rules24Flag">
            ＊{one(formID)}で特殊関数oneのユーザparamを元に値決定
            *[formID]で同一ページの値を元に対象情報を検索
          </v-row>
          <!------------------------------- ---->
          <v-row>
            <v-col cols="4">
              <v-checkbox
                v-model="rules[2]"
                value="true"
                label="特定フォームに値を保存"
              ></v-checkbox>
            </v-col>
            <v-col cols="1">
              <v-btn v-if="rules[2]" @click="addTarget" class="ma-2"
                >追加</v-btn
              >
            </v-col>
            <v-col cols="1">
              <v-btn v-if="rules[2]" @click="delTarget" class="ma-2"
                >削除</v-btn
              >
            </v-col>
            <v-col
              class="ma-2"
              cols="3"
              v-if="rules[2] == 'true' && rules[7] == 'true'"
            >
              <search-Page
                :label="'サブページのformID'"
                v-model="rules[8]"
                required
                samePage
                :initPageID="Number($route.params.page_id)"
              ></search-Page>
            </v-col>
          </v-row>
          <!------------------------------- ---->
          <div
            v-for="(target, j) in targetFormIDs"
            :key="`sensor-${j}`"
            class="mb-4"
          >
            <v-row v-if="rules[2] == 'true'">
              <v-col cols="1">
                <search-Page
                  :label="
                    targetSaveValus[j] == 'SendMail' ? 'pageID' : 'formID'
                  "
                  v-model="targetFormIDs[j]"
                  required
                ></search-Page>
              </v-col>
              <v-col cols="3">
                <v-select
                  :items="saveType"
                  v-model="targetSaveValus[j]"
                  item-text="text"
                  item-value="value"
                  label="保存データ"
                  :rules="[varidation.required]"
                  :hint="
                    targetSaveValus[j] == 'AND' ? '格納する値は最後に指定' : ''
                  "
                  persistent-hint
                ></v-select>
              </v-col>
              <v-col cols="3">
                <v-text-field
                  :label="
                    targetSaveValus[j] == 'SendMail'
                      ? '条件対象フォームID(.区切り)'
                      : '条件対象フォームID'
                  "
                  :rules="[]"
                  v-model="targetTarmsID[j]"
                  required
                  hint="先頭!で!=条件に変換"
                  persistent-hint
                ></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field
                  label="if == X"
                  :rules="[]"
                  v-model="targetTarmsValue[j]"
                  required
                ></v-text-field>
              </v-col>
              <v-col
                cols="2"
                v-if="
                  targetSaveValus[j] == 'target' ||
                    targetSaveValus[j] == 'formID' ||
                    targetSaveValus[j] == 'formIDadd' ||
                    targetSaveValus[j] == 'formIDToSub'
                "
              >
                <v-text-field
                  :label="targetSaveValus[j] == 'target' ? '固定値' : 'formID'"
                  :rules="[]"
                  v-model="targetValues[j]"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </div>
          <!------------------------------- ---->
          <v-row>
            <v-col cols="2">
              <v-checkbox
                v-model="rules[17]"
                label="押下条件"
                value="true"
                false-value=""
              ></v-checkbox>
            </v-col>
            <v-col cols="1">
              <v-btn v-if="rules[17]" @click="addClick(1)" class="ma-2"
                >追加</v-btn
              >
            </v-col>
            <v-col cols="1">
              <v-btn v-if="rules[17]" @click="delClick(1)" class="ma-2"
                >削除</v-btn
              >
            </v-col>
            <v-col> *開いたときのクリック可・不可</v-col>
          </v-row>

          <div
            v-for="(clickTerm, i) in clickTerms"
            :key="`17-${i}`"
            class="mb-4"
          >
            <v-row v-if="rules[17]">
              <v-col cols="2">
                <div v-if="i != 0">
                  <v-select
                    :items="joinTerm"
                    v-model="joinTerms[i]"
                    label="AND OR"
                    :rules="[varidation.required]"
                  ></v-select>
                </div>
              </v-col>
              <v-col cols="3">
                <v-select
                  label="条件"
                  v-model="clickTerms[i]"
                  item-text="label"
                  item-value="value"
                  :items="selectclickTerms"
                ></v-select>
                *1 or条件で連結される
              </v-col>
              <v-col cols="2" v-if="clickTerms[i] == 'role'">
                <v-select
                  label="権限レベル"
                  :rules="[]"
                  v-model="clickTermValues[i]"
                  item-text="label"
                  item-value="value"
                  :items="selectRole"
                ></v-select>
              </v-col>
              <v-col
                cols="2"
                v-else-if="
                  clickTerms[i] == 'formID' || clickTerms[i] == 'UserformID'
                "
              >
                <v-text-field
                  label="条件対象formID"
                  :rules="[]"
                  v-model="clickTermValues[i]"
                  required
                ></v-text-field>
              </v-col>
              <v-col
                cols="2"
                v-if="
                  clickTerms[i] == 'formID' || clickTerms[i] == 'UserformID'
                "
              >
                <v-text-field
                  label="if == X"
                  :rules="[]"
                  v-model="clickTermCondition[i]"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="4" v-else-if="clickTerms[i] == 'special'">
                <v-text-field
                  label="関数名"
                  :rules="[]"
                  v-model="clickTermCondition[i]"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </div>
          <v-row>
            <v-col cols="2">
              <v-checkbox
                v-model="rules29Flag"
                label="特定フォーム入力後押下可能"
              ></v-checkbox>
            </v-col>
            <v-col cols="1" v-if="rules29Flag">
              <v-btn @click="addClick(2)" class="ma-2">追加</v-btn>
            </v-col>
            <v-col cols="1" v-if="rules29Flag">
              <v-btn @click="delClick(2)" class="ma-2">削除</v-btn>
            </v-col>
          </v-row>
          <div
            v-for="(requiredSubFormID, i) in requiredSubFormIDs"
            :key="`29-${i}`"
          >
            <v-row>
              <v-col cols="2"></v-col>
              <v-col cols="2" v-if="rules29Flag">
                <v-text-field
                  label="サブページのformID"
                  v-model="requiredSubFormIDs[i]"
                  :rules="[varidation.required]"
                  hint="同一ページは0。親ページは-1かつ親ページの情報伝達を有効にしてください。"
                ></v-text-field>
              </v-col>
              <v-col cols="2" v-if="rules29Flag">
                <v-text-field
                  label="必須項目のformID"
                  v-model="requiredFormIDs[i]"
                  :rules="[varidation.required]"
                ></v-text-field>
              </v-col>
              <v-col cols="2" v-if="rules29Flag">
                <v-text-field
                  label="入力不可時のラベル"
                  v-model="requiredLabels[i]"
                  :rules="[varidation.required]"
                  hint="上から連結し、連結情報のみ追加したい場合は二つのformIDを0にしてください。"
                ></v-text-field>
              </v-col>
            </v-row>
          </div>
          <v-row>
            <v-col cols="3">
              <v-checkbox
                v-model="rules25Flag"
                label="マスターデータ内のサブページ分サブページを生成"
              ></v-checkbox>
            </v-col>
            <v-col cols="1" v-if="rules25Flag">
              <v-btn @click="addClick(3)" class="ma-2">追加</v-btn>
            </v-col>
            <v-col cols="1" v-if="rules25Flag">
              <v-btn @click="delClick(3)" class="ma-2">削除</v-btn>
            </v-col>
          </v-row>
          <div
            v-for="(rules25MasterFormID, i) in rules25MasterFormIDs"
            :key="`25-${i}`"
          >
            <v-row>
              <v-col cols="2" v-if="rules25Flag">
                <v-text-field
                  label="マスターデータ格納先formID"
                  v-model="rules25MasterFormIDs[i]"
                  :rules="[]"
                ></v-text-field>
              </v-col>
              <v-col cols="2" v-if="rules25Flag">
                <v-text-field
                  label="生成先サブページformID"
                  v-model="rules25SubpageFormIDs[i]"
                  :rules="[]"
                ></v-text-field>
              </v-col>
              <v-col cols="2" v-if="rules25Flag">
                <v-text-field
                  label="マスタデータサブページformID"
                  v-model="rules25MasterSubpageFormIDs[i]"
                  :rules="[]"
                ></v-text-field>
              </v-col>
              <v-col cols="3" v-if="rules25Flag">
                <v-text-field
                  label="どのデータをどこに格納するかの指定"
                  hint="マスタデータ内のformID.表示先formID:以降同じ"
                  v-model="rules25PosFromTos[i]"
                  :rules="[]"
                ></v-text-field>
              </v-col>
            </v-row>
          </div>
        </v-form>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        :color="returnData.color + ' ' + textColor"
        v-show="showButton"
        @click.once="submit"
        v-on:mouseover="backOpacity = 'opacity: 0.1'"
        v-on:mouseleave="backOpacity = 'opacity: 1'"
        fixed
        bottom
        right
        x-large
        class="mr-10 mb-8"
        >OK</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import searchPage from "./common/searchPage.vue";
import setCols from "./common/setCols.vue";
export default {
  components: {
    setCols,
    searchPage,
  },
  props: {
    //共通値
    type: Number,
    position: Number,
    label: String,
    cols: String,
    //個別値
    init: String,
    color: String,
    rule: String,
  },
  data() {
    return {
      returnData: {
        //共通値
        type: this.type,
        position: this.position,
        label: this.label,
        cols: this.cols,
        //個別値
        init: this.init,
        rule: this.rule,
        color: this.color,
      },
      backOpacity: "opacity: 1",
      showButton: false,
      rules: [0, 0, 0, "", null, null, null],
      formIDs: [0],
      actions: ["on"],
      //
      saveType: [
        { text: "日時", value: "date" },
        { text: "時刻", value: "time" },
        { text: "固定値", value: "target" },
        { text: "削除", value: "delete" },
        { text: "ユーザ名", value: "userName" },
        { text: "特定フォームの値", value: "formID" },
        { text: "特定フォーム追記(,)", value: "formIDadd" },
        { text: "特定フォームの値(親→サブへ保存)", value: "formIDToSub" },
        { text: "メール送信(作成中)", value: "SendMail" },
        { text: "AND条件", value: "AND" },
        //{ text: "OR条件", value: "OR" }, //バグがでるため禁止
      ],
      targetFormIDs: [0], //rules[12]
      targetSaveValus: ["0"], //rules[13]
      targetValues: [""], //rules[14]
      targetTarmsID: [""], //rules[15]
      targetTarmsValue: [""], //rules[16]
      //押下条件
      clickTerms: ["role"], //rules[18]
      clickTermValues: ["0"], //rules[19]
      clickTermCondition: ["状態A"], //rules[20]
      joinTerms: ["OR"], //rules[23]
      joinTerm: ["AND", "OR", "AND(", "OR(", "AND)", "OR)"],
      requiredSubFormIDs: ["0"],
      requiredFormIDs: ["0"],
      requiredLabels: [""],
      selectclickTerms: [
        { label: "ユーザ権限", value: "role" },
        { label: "特定フォーム値", value: "formID" },
        { label: "ユーザ情報の特定フォーム値", value: "UserformID" },
        { label: "特殊関数", value: "special" },
      ],
      selectRole: [
        { label: "一般", value: "0" },
        { label: "管理者", value: "1" },
        { label: "第3属性", value: "2" },
      ],
      //メール送信関連
      mailSend: ["0.0", "グループ情報.アクション名", "0"],
      //
      select: ["on", "off"],
      textColor: "",
      textColors: [
        { label: "black", value: "" },
        { label: "white", value: "text" },
      ],
      fixMode: [{ label: "左下", value: "fixed bottom left" }],
      //
      rules24Flag: false,
      rules25Flag: false,
      rules25MasterFormIDs: ["0"],
      rules25SubpageFormIDs: ["0"],
      rules25MasterSubpageFormIDs: ["0"],
      rules25PosFromTos: [""],
      rules29Flag: false,
      rules32Flag: false,
      rules33Flag: false,

      //バリデーション
      valid: true,
      varidation: {
        numonly: (value) => {
          return /^[0-9]*$/.test(value) || "数値のみ";
        },
        cols: (value) => {
          return /^([0-9]|1[0-2]|auto)$/.test(value) || "0~12,autoのみ";
        },
        required: (value) => !!value || "必須項目です",
      },
    };
  },
  mounted() {
    setTimeout(() => {
      this.showButton = true;
    }, 500);

    if (typeof this.rule != "undefined") {
      this.rules = this.rule.split(",");
      if (this.rules.length > 5) {
        this.formIDs = this.rules[5].split(":");
        this.actions = this.rules[6].split(":");
      }
      if (this.rules[2] == "true") {
        this.targetFormIDs = this.rules[12].split(":");
        this.targetSaveValus = this.rules[13].split(":");
        this.targetValues = this.rules[14].split(":");
        this.targetTarmsID = this.rules[15].split(":");
        this.targetTarmsValue = this.rules[16].split(":");
      }
      if (this.rules[17] == "true") {
        this.clickTerms = this.rules[18].split(":");
        this.clickTermValues = this.rules[19].split(":");
        this.clickTermCondition = this.rules[20].split(":");
        this.joinTerms = this.rules[23].split(":");
      }
      [this.returnData.color, this.textColor] = this.color.split(",");
      if (this.nullCheck(this.rules[24])) {
        this.rules24Flag = "true";
        this.mailSend = this.rules[24].split(":");
      }
      if (this.nullCheck(this.rules[25])) {
        this.rules25Flag = true;
        let tmp1 = [];
        let tmp2 = [];
        let tmp3 = [];
        let tmp4 = [];
        [tmp1, tmp2, tmp3, tmp4] = this.rules[25].split("/");
        this.rules25MasterFormIDs = tmp1.split("*");
        this.rules25SubpageFormIDs = tmp2.split("*");
        this.rules25MasterSubpageFormIDs = tmp3.split("*");
        this.rules25PosFromTos = tmp4.split("*");
      }
      if (this.nullCheck(this.rules[29])) {
        this.rules29Flag = true;
        let tmp1 = [];
        let tmp2 = [];
        let tmp3 = [];
        [tmp1, tmp2, tmp3] = this.rules[29].split(":");
        this.requiredSubFormIDs = tmp1.split(".");
        this.requiredFormIDs = tmp2.split(".");
        this.requiredLabels = tmp3.split(".");
      }
      if (this.nullCheck(this.rules[32])) {
        this.rules32Flag = true;
      }
      if (this.nullCheck(this.rules[33])) {
        this.rules33Flag = true;
      }
    }
  },
  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        if (this.rules[0] == "0") {
          this.returnData.init = "";
        }
        //特定フォームに値を保存
        if (this.rules[2] != "true") {
          this.rules[3] = "0";
          this.rules[12] = "";
          this.rules[13] = "";
          this.rules[14] = "";
          this.rules[15] = "";
          this.rules[16] = "";
        } else {
          this.rules[3] = this.targetFormIDs[0];
          this.rules[12] = this.targetFormIDs.join(":");
          this.rules[13] = this.targetSaveValus.join(":");
          this.targetSaveValus.forEach((v, i) => {
            if (
              v != "target" &&
              v != "formID" &&
              v != "formIDadd" &&
              v != "formIDToSub"
            ) {
              this.targetValues[i] = "";
            }
          });
          this.rules[14] = this.targetValues.join(":");
          this.rules[15] = this.targetTarmsID.join(":");
          this.rules[16] = this.targetTarmsValue.join(":");
        }
        //押下制限
        if (this.rules[17] == "true") {
          this.rules[18] = this.clickTerms.join(":");
          this.rules[19] = this.clickTermValues.join(":");
          this.rules[20] = this.clickTermCondition.join(":");
          this.rules[23] = this.joinTerms.join(":");
        } else {
          this.rules[18] = "";
          this.rules[19] = "";
          this.rules[20] = "";
          this.rules[23] = "";
        }

        if (this.rules[4] != "true") {
          this.formIDs = [0];
          this.rules[5] = "0";
          this.rules[6] = "";
          this.actions = null;
        }
        //formIDsをrule[5]に格納
        if (this.rules.length > 5) {
          this.rules[5] = this.formIDs.join(":");
          if (this.actions != null) {
            this.rules[6] = this.actions.join(":");
          }
        }
        if (this.rules[0] != "4") {
          this.rules[22] = "";
        }
        //メール送信
        if (this.nullCheck(this.rules24Flag) && this.rules[21] == "true") {
          this.rules24Flag = "true";
          this.rules[24] = this.mailSend.join(":");
        } else {
          this.rules[24] = null;
        }

        if (this.nullCheck(this.rules25Flag)) {
          this.rules[25] =
            this.rules25MasterFormIDs.join("*") +
            "/" +
            this.rules25SubpageFormIDs.join("*") +
            "/" +
            this.rules25MasterSubpageFormIDs.join("*") +
            "/" +
            this.rules25PosFromTos.join("*");
        } else {
          this.rules[25] = null;
        }

        if (this.rules[28] == "true") {
          //サブページのモーダルONと競合するため、OFF
          this.rules[9] = null;
        }
        if (this.rules29Flag) {
          this.rules[29] =
            this.requiredSubFormIDs.join(".") +
            ":" +
            this.requiredFormIDs.join(".") +
            ":" +
            this.requiredLabels.join(".");
        } else {
          this.rules[29] = "";
        }

        if (!this.rules32Flag) {
          this.rules[32] = null;
        }
        if (!this.rules33Flag) {
          this.rules[33] = null;
        }

        this.returnData.color += "," + this.textColor;
        this.returnData.rule = this.rules.join(",");
        if (String(this.returnData.rule).length < 1024) {
          this.$emit("clickSubmit", this.returnData);
        } else {
          alert(
            "ruleの文字数が1023を超えました。:",
            String(this.returnData.rule).length
          );
        }
      }
    },
    add() {
      const max = 10;
      if (this.formIDs.length < max && this.actions.length < max) {
        this.formIDs.push("0");
        this.actions.push("on");
      }
    },
    del() {
      if (this.formIDs.length > 1 && this.actions.length > 1) {
        this.formIDs.splice(-1, 1);
        this.actions.splice(-1, 1);
      }
    },
    addTarget() {
      this.targetFormIDs.push(0);
      this.targetSaveValus.push("0");
      this.targetValues.push("0");
      this.targetTarmsID.push("");
      this.targetTarmsValue.push("");
    },
    delTarget() {
      this.targetFormIDs.splice(-1, 1);
      this.targetSaveValus.splice(-1, 1);
      this.targetValues.splice(-1, 1);
      this.targetTarmsID.splice(-1, 1);
      this.targetTarmsValue.splice(-1, 1);
    },
    addClick(Index) {
      const i = this.joinTerms.length - 1;
      const j = this.requiredSubFormIDs.length - 1;
      const k = this.rules25MasterFormIDs.length - 1;
      switch (Index) {
        case 1:
          this.joinTerms.push(this.joinTerms[i]);
          this.clickTerms.push(this.clickTerms[i]);
          this.clickTermValues.push(this.clickTermValues[i]);
          this.clickTermCondition.push(this.clickTermCondition[i]);
          break;
        case 2:
          this.requiredSubFormIDs.push(this.requiredSubFormIDs[j]);
          this.requiredFormIDs.push(this.requiredFormIDs[j]);
          this.requiredLabels.push(this.requiredLabels[j]);
          break;
        case 3:
          this.rules25MasterFormIDs.push(this.rules25MasterFormIDs[k]);
          this.rules25SubpageFormIDs.push(this.rules25SubpageFormIDs[k]);
          this.rules25MasterSubpageFormIDs.push(
            this.rules25MasterSubpageFormIDs[k]
          );
          this.rules25PosFromTos.push(this.rules25PosFromTos[k]);
          break;
        default:
      }
    },
    delClick(Index) {
      switch (Index) {
        case 1:
          this.joinTerms.splice(-1, 1);
          this.clickTerms.splice(-1, 1);
          this.clickTermValues.splice(-1, 1);
          this.clickTermCondition.splice(-1, 1);
          break;
        case 2:
          this.requiredSubFormIDs.splice(-1, 1);
          this.requiredFormIDs.splice(-1, 1);
          this.requiredLabels.splice(-1, 1);
          break;
        default:
      }
    },
    nullCheck(value) {
      let checkFlag = true;
      switch (value) {
        case "":
        case "undefined":
        case null:
        case undefined:
        case false:
          checkFlag = false;
      }

      return checkFlag;
    },
    deleteRule31() {
      if (this.rules[21] !== "true") {
        this.rules[31] = "";
      }
    },
  },
};
</script>
